module.exports = __webpack_public_path__ + "static/media/Screenshot_7.ca1d51ff.png";